<div class="wrap qo-flex-col-top-left">
	<h1
		class="qo-padding20">{{!data.punchedIn ? ('PUNCH_CLOCK.START_PUNCH' | translate) : ('PUNCH_CLOCK.STOP_PUNCH' | translate)}}</h1>
	<div class="line-separator"></div>
	<div class="qo-padding20">
		<div class="qo-flex-col-top-left medium-text">
			<div class="qo-flex-row-top-left">
				{{'PUNCH_CLOCK.START_OF_PUNCH' | translate}}:
				<div
					class="qo-margin-left10  bold">{{data.punchedIn ? data.shift.punch_start.localDate.format('HH:mm:ss') : dateNow | smLocalDate: 'HH:mm:ss'}}</div>
			</div>
			<div class="qo-flex-row-top-left qo-margin-top25" *ngIf="data.punchedIn">
				{{'PUNCH_CLOCK.END_OF_PUNCH' | translate}}:
				<div
					class="qo-margin-left10 bold">{{dateNow | smLocalDate: 'HH:mm:ss'}}</div>
			</div>
		</div>
	</div>
	<div class="line-separator"></div>
	<form [formGroup]="form">
		<div
			class="qo-label qo-padding20 qo-margin-top20"
			*ngIf="!data.punchedIn"
		>
			<div class="qo-form-row qo-margin-top10">
				<qo-form-block
					[label]="'GROUPS.GROUPS' | translate"
				>
					<qo-input-select
						[formControl]="selectedGroupControl"
						[placeholder]="'PUNCH_CLOCK.SELECT_GROUP' | translate"
						[options]="groupsSelectData"
					></qo-input-select>
				</qo-form-block>
			</div>
		</div>
		<div class="qo-padding20 width100 qo-margin-top20" *ngIf="data.punchedIn">
			<label class="qo-label ">
				{{'ACTIONS.NOTE' | translate}}
				<textarea
					class="qo-input text-area"
					formControlName="punchNote"
					[rows]="5"
				>
			</textarea>
			</label>
		</div>
	</form>
	<div class="qo-padding20 qo-margin-top20 qo-flex-row-space-between btn-sticky-sm">
		<button
			class="qo-button-standard qo-grey"
			(click)="close()"
		>{{'cancel_all' | translate}}</button>
		<button
			[disabled]="!data.punchedIn && !selectedGroupControl.value"
			[ngClass]="data.punchedIn ? 'qo-button-standard qo-no' : 'qo-button-standard qo-primary'"
			(click)="punchButtonPressed()"
		>
			<qo-icon [icon]="data.punchedIn ?  EQORebrandIcon.pause_circle_dark : EQORebrandIcon.play_dark" [size]="'sm'"
							 [color]="EQORebrandColor.WHITE"></qo-icon>
			{{data.punchedIn ? ('PUNCH_CLOCK.STOP_PUNCH' | translate) : ('PUNCH_CLOCK.START_PUNCH' | translate)}}
		</button>
	</div>
</div>
